import { render, staticRenderFns } from "./DocumentFactBatches.vue?vue&type=template&id=46044ae2&scoped=true&"
import script from "./DocumentFactBatches.vue?vue&type=script&lang=js&"
export * from "./DocumentFactBatches.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFactBatches.vue?vue&type=style&index=0&id=46044ae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46044ae2",
  null
  
)

export default component.exports